import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import "antd/dist/antd.css";

import Router from "./router";
import i18n from "./translation";

const App = () => (
  <BrowserRouter>
    <I18nextProvider i18n={i18n}>
      <Router />
    </I18nextProvider>
  </BrowserRouter>
);

try {
  const container = document.getElementById("root");
  if (!container) throw new Error('Failed to find the root element');
  const root = createRoot(container);
  root.render(<App />);
} catch (error) {
  console.error('Error mounting React app:', error);
}
